/*
 * Simam Digital — WebXR Showcases catalogue (hub card data).
 *
 * `stat` is an honest highlight of the *demo* itself (not a client metric).
 * `caseStudy` is only set where the demo genuinely maps to real Simam client
 * work on simamdigital.com — never fabricate a case study for a tech demo.
 *
 * Copyright (c) 2026 Simam Digital Ltd.
 */

export const SHOWCASES = [
	{
		title: 'Sneaker Builder',
		href: './sneaker-builder/',
		badge: 'Mixed Reality',
		icon: 'sneaker',
		accent: '#a855f7',
		stat: 'Mixed reality · WebXR',
		description:
			'Hold, inspect, recolour and size up a virtual sneaker in your own space — a spatial product configurator for retail.',
	},
	{
		title: 'RealMeasure',
		href: './realmeasure/',
		badge: 'Mixed Reality',
		icon: 'measure',
		accent: '#7c3aed',
		stat: 'Controller measuring',
		description:
			'A real-world measuring tape for your headset. Point, tap and read off distances anywhere in the room.',
	},
	{
		title: 'Chairs Etc',
		href: './chairs-etc/',
		badge: 'Mixed Reality',
		icon: 'chair',
		accent: '#c084fc',
		stat: '11 furniture models',
		description:
			'Place, rotate and rearrange virtual furniture in your physical room — the future of spatial shopping.',
	},
	{
		title: 'Flap Frenzy',
		href: './flap-frenzy/',
		badge: 'Virtual Reality',
		icon: 'flap',
		accent: '#8b5cf6',
		stat: 'Full-body VR',
		description:
			'Flap your arms to fly through shrinking target rings in this full-body VR arcade game.',
	},
	{
		title: 'Flow',
		href: './fluid-flow/',
		badge: 'Interactive · WebGL',
		icon: 'flow',
		accent: '#ff5a1f',
		stat: 'GPU fluid · mobile-ready',
		description:
			'A real-time GPU fluid you can stir with a finger — a tactile demo of what the open web can render.',
	},
	{
		title: 'Global Signals',
		href: './globe-viz/',
		badge: 'Interactive · Data Viz',
		icon: 'globe',
		accent: '#2d6bff',
		stat: '12 live sites',
		description:
			'A live operations globe with animated routes and site telemetry — the view we build for logistics & digital-twin dashboards.',
	},
	{
		title: 'Digital Twin',
		href: './digital-twin/',
		badge: 'Interactive · 3D Ops',
		icon: 'twin',
		accent: '#ff5a1f',
		stat: '6 live units · realtime KPIs',
		description:
			'A live industrial digital twin — explore a 3D offshore platform with real-time KPIs, alerts and clickable equipment.',
	},
	{
		title: 'Virtual Expo',
		href: './virtual-expo/',
		badge: 'Interactive · Virtual Event',
		icon: 'expo',
		accent: '#16b364',
		stat: '6 pavilions',
		description:
			'Walk through a colourful 3D exhibition of pavilions — our take on explorable virtual events and conferences.',
		caseStudy: {
			href: 'https://www.simamdigital.com/case-study-web-gl-experience.html',
			label: 'Real project · 6,000+ attendees',
		},
	},
	{
		title: 'Green Earth',
		href: './green-earth/',
		badge: 'Interactive · Explorable World',
		icon: 'earth',
		accent: '#4ade80',
		stat: '5 explorable biomes',
		description:
			'Spin a living planet, pick a restoration zone, then drop in and explore procedurally generated terrain first-person.',
		caseStudy: {
			href: 'https://www.simamdigital.com/case-study-green-earth-metaverse.html',
			label: 'Inspired by · Green Earth Metaverse',
		},
	},
];
